import { generateTranslationTools } from '@tanium/react-i18n';

import german from './static/locales/de-DE/tanviz.json';
import english from './static/locales/en-US/tanviz.json';
import french from './static/locales/fr-FR/tanviz.json';
import japanese from './static/locales/ja-JP/tanviz.json';
import korean from './static/locales/ko-KR/tanviz.json';

export const { Trans, useTranslation } = generateTranslationTools('tanviz', {
  'de-DE': { tanviz: german },
  'en-US': { tanviz: english },
  'fr-FR': { tanviz: french },
  'ja-JP': { tanviz: japanese },
  'ko-KR': { tanviz: korean },
});
